import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let StreetTableColumnMappingService = class StreetTableColumnMappingService {
    streetTableColumnMap = new BehaviorSubject(null);
    streetTableColumnMapObservable = this.streetTableColumnMap.asObservable();
    streetTableItems = new BehaviorSubject(null);
    streetTableItemsObservable = this.streetTableItems.asObservable();
    createApplication = new BehaviorSubject(null);
    createApplicationObservable = this.createApplication.asObservable();
    constructor() {
    }
    setStreetTableColumnMap(tableColumnMap) {
        this.streetTableColumnMap.next(tableColumnMap);
    }
    setStreetTableItems(tableItems) {
        this.streetTableItems.next(tableItems);
    }
    createApplicationRequest(property) {
        this.createApplication.next(property);
    }
    static ctorParameters = () => [];
};
StreetTableColumnMappingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], StreetTableColumnMappingService);
export { StreetTableColumnMappingService };
